import React, { useEffect, useState } from "react";
import moment from "moment";
import { isEmpty } from "lodash";
import { useContextSelector } from "use-context-selector";
import { useTranslation } from "react-i18next";
import Layout from "../Layout";
import AuthContext from "../../context/AuthContext";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";

const AccountStatementProfile = () => {
  const { t } = useTranslation();
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });

  const [listing, setListing] = useState([]);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });

  const getData = async (object = filter, type) => {
    try {
      const { status, data } = await apiGet(apiPath.accountStatement, object);

      const result = data?.success ? data?.results?.data : [];
      setData(result);

      if (type == "add") {
        setListing([...listing, ...data?.results?.data]);
      } else {
        setListing(data?.results?.data);
      }
    } catch (error) {}
  };

  const handleLoadMore = () => {
    const nextFilter = { ...filter, page: filter?.page + 1 };
    setFilter(nextFilter);
    getData(nextFilter, "add");
  };

  useEffect(() => {
    if (!isEmpty(user)) {
      getData();
    }
  }, [user]);

  return (
    <Layout>
      <div>
        <div className="history-overview-wrapper">
          <div className="desktop_card v-card v-sheet theme--light elevation-0">
            <div style={{marginTop:"20px"}} className="history-card v-card v-sheet theme--light elevation-0">
              {listing?.length > 0 ? (
                listing.map((res) => (
                  <div
                    key={res?._id}
                    className="row mx-1 mobile-reward-table"
                  >
                    <div className="mr-0 col col-6">
                      <div className="row reward-table-header pl-6 no-gutters">
                        <div className="col col-12">{t("Type")}</div>
                        <div className="col col-12">
                          {!isEmpty(res?.casinoBetId)
                            ? t("Amount")
                            : res?.transactionType === "credit"
                              ? t("Credits")
                              : t("Debits")}
                        </div>
                        <div className="col col-12">{t("Balance")}</div>
                        <div className="col col-12">
                          {!isEmpty(res?.casinoBetId) ? t("GameInfo") : t("Remark")}
                        </div>
                        {!isEmpty(res?.casinoBetId) && (
                          <>
                            <div className="col col-12">{t("Stake")}</div>
                            <div className="col col-12">{t("ProfitLoss")}</div>
                          </>
                        )}
                        {isEmpty(res?.casinoBetId) &&
                          !isEmpty(res?.createdByData?.username) && (
                            <div className="col col-12">
                              {res?.createdByData?.username}
                            </div>
                          )}
                        <div className="col col-12">{t("Date")}</div>
                      </div>
                    </div>
                    <div className="col col-6">
                      <div className="row no-gutters">
                        <div className="col col-12">
                          {!isEmpty(res?.casinoBetId)
                            ? res?.casinoBetId
                            : res?.transactionType === "credit"
                              ? t("Credits")
                              : t("Debits")}
                        </div>
                        <div
                          className="col col-12"
                          style={{
                            color:
                              res?.transactionType === "credit"
                                ? "green"
                                : "red",
                          }}
                        >
                          {res?.transactionType === "credit"
                            ? res?.amount?.toFixed(2)
                            : `(${res?.amount?.toFixed(2)})`}
                        </div>
                        <div className="col col-12">
                          {res?.newBalance?.length > 0
                            ? res?.newBalance[0]?.toFixed(2)
                            : 0.0}
                        </div>
                        <div className="col col-12">
                          {!isEmpty(res?.casinoBetId)
                            ? `${res?.platform} - ${res?.gameInfo}`
                            : res?.remark || t("NA")}
                        </div>
                        {!isEmpty(res?.casinoBetId) && (
                          <>
                            <div className="col col-12">{res?.betAmount}</div>
                            <div className="col col-12">
                              {res?.realCutAmount}
                            </div>
                          </>
                        )}
                        {isEmpty(res?.casinoBetId) &&
                          !isEmpty(res?.createdByData?.username) && (
                            <div className="col col-12">
                              {res?.userData?.firstName ||
                                res?.userData?.lastName}
                            </div>
                          )}
                        <div className="col col-12">
                          {moment(res?.createdAt || res?.timeInserted).format(
                            "YYYY-MM-DD HH:mm:ss",
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col col-12">
                      <hr
                        role="separator"
                        aria-orientation="horizontal"
                        className="mx-2 v-divider theme--light"
                      />
                    </div>
                  </div>
                ))
              ) : (
                <div className="row">
                  <div className="text-center pt-0 pb-8 col col-12">
                    <label className="referral-table-header subtitle-2">
                      {t("NoDataAvailable")}
                    </label>
                  </div>
                </div>
              )}

              {data?.hasNextPage && (
                <div className="row no-gutters justify-center">
                  <div className="col col-6 pt-2 pb-4">
                    <button
                      type="button"
                      onClick={handleLoadMore}
                      className="history-tab-mobile v-btn v-btn--has-bg theme--light v-size--default primary"
                      style={{ width: "100%" }}
                    >
                      <span className="v-btn__content">
                        <span>{t("LoadMore")}</span>
                      </span>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AccountStatementProfile;
